import { Modal } from "antd";

const WarningModal = ({ open, onClose, message, title = "Warning" }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}                 // No buttons
      centered
      width={400}
    >
      <h3 style={{ color: "#faad14", marginBottom: 12 }}>{title}</h3>
      <p style={{ fontSize: 15 }}>{message}</p>

      <div style={{ textAlign: "right", marginTop: 20 }}>
        <button
          onClick={onClose}
          style={{
            padding: "6px 16px",
            backgroundColor: "#faad14",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default WarningModal;
